import { FunctionComponent } from 'react';
import Divider from '@mui/material/Divider';
import { getDrawerSxTransitionMixin } from '../_helpers/transition';
import { INavigationDividerItemProps } from './NavigationDividerItem.interface';

export const NavigationDividerItem: FunctionComponent<INavigationDividerItemProps> = (props) => {
  const { hasBottomMargin, hasDrawerTransitions, isFullyExpanded } = props;

  return (
    <Divider
      component={'li'}
      sx={{
        borderBottomWidth: 2,
        mx: 1,
        mt: 1,
        mb: hasBottomMargin ? 1 : 0,
        ...(hasDrawerTransitions
          ? getDrawerSxTransitionMixin(isFullyExpanded, 'margin')
          : {}),
      }}
    />
  );
};
